import { useEffect, useState } from "react";
import { Construction, X } from "lucide-react";

const STORAGE_KEY = "enthida_construction_notice";

const ConstructionNotice = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let dismissed = null;
    try {
      dismissed = sessionStorage.getItem(STORAGE_KEY);
    } catch (e) {
      // sessionStorage blocked
    }
    if (!dismissed) {
      const t = setTimeout(() => setVisible(true), 600);
      return () => clearTimeout(t);
    }
  }, []);

  const close = () => {
    try {
      sessionStorage.setItem(STORAGE_KEY, "dismissed");
    } catch (e) {
      // ignore
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed top-32 inset-x-4 sm:inset-x-auto sm:left-1/2 sm:-translate-x-1/2 sm:w-[calc(100%-2rem)] sm:max-w-xl z-[90] animate-fadeIn pointer-events-none"
      data-testid="construction-notice"
    >
      <div className="pointer-events-auto relative bg-gradient-to-br from-[#121212] to-[#0e0e0e] border border-[#00d4aa]/25 rounded-2xl shadow-2xl shadow-black/50 px-5 py-4 pr-12">
        <div className="absolute -top-px left-12 right-12 h-px bg-gradient-to-r from-transparent via-[#00d4aa]/60 to-transparent" />

        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-[#7ed321]/15 to-[#00d4aa]/15 flex items-center justify-center shrink-0">
            <Construction size={18} className="text-[#00d4aa]" />
          </div>
          <div className="flex-1">
            <p className="text-white font-medium text-sm mb-0.5">
              Diese Seite befindet sich aktuell im Aufbau.
            </p>
            <p className="text-[#a1a1aa] text-xs leading-relaxed">
              Einige Inhalte und Funktionen sind noch nicht vollständig.
              Bei Fragen erreichen Sie mich jederzeit telefonisch oder per WhatsApp.
            </p>
          </div>
        </div>

        <button
          onClick={close}
          aria-label="Hinweis schließen"
          className="absolute top-3 right-3 w-7 h-7 rounded-lg hover:bg-white/5 flex items-center justify-center text-[#71717a] hover:text-white transition-colors"
          data-testid="construction-notice-close"
        >
          <X size={15} />
        </button>
      </div>
    </div>
  );
};

export default ConstructionNotice;
